import React from "react";
import Layout from "../../../components/common/layout";
import InvitePage from "../../../components/invite/invite";
const Invite = () => {
  return (
    <>
      <Layout
        heading="Invite Staff Account"
        isTeamInvite
        curr={2}
        page={<InvitePage />}
      />
    </>
  );
};

export default Invite;
